module.exports = __webpack_public_path__ + "img/2018-12-14.041f71d4.jpg";